/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
// import { getOSCollective } from "../../utils";
// import { isEmptyObj } from "../../utils/helper";
import { isEmptyObj } from "../../utils/helper";
import { style } from "./styles";
import Button from "../common/Button";
import { getGohonzonType } from "../../utils";

function ReturnedGohonzonHandover({
  member,
  onHandoverApplication,
  onMemberSelect,
}) {
  if (isEmptyObj(member)) {
    return null;
  }
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.fullName || "-"}
        <br />
        {member.memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.mobileNumber || "-"}
        <br />
        {member.memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.memberDetails.regionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.appliedBy || "-"} <br />
        on:{" "}
        {/* {member.appliedAt !== null ? moment(member.appliedAt).format("L") : "-"} */}
        {member.appliedAt ? moment(member.appliedAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell }}>
        <Box style={style.status}>Application Verified</Box>
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon
            style={style.icon}
            onClick={() => onMemberSelect(member.memberId, "return/preview")}
          />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              variant="outlined"
              onClick={() => onHandoverApplication(member)}
              style={{ ...style.actionBtn }}
              label="HANDOVER"
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default ReturnedGohonzonHandover;
